export default __webpack_public_path__ + "static/media/logo-footer.04ca5c92.png";